import {UPDATE_SHOPIFY_MODE_SETTINGS} from '.';

const processShopifyModeMessage = (message, {dispatch}) => {
  const {shopifySettings} = message;
  if (shopifySettings) {
    dispatch({
      type: UPDATE_SHOPIFY_MODE_SETTINGS,
      shopifySettings
    });
  }
};

export default processShopifyModeMessage;
